export default __webpack_public_path__ + "static/media/tool-icon-goal-upper.d711a311.svg";